<template>
  <div>
    <b-row style="margin-top: 40px;">
      <b-col cols="12">
        <!-- 戏曲热榜 -->
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <h4>戏曲热榜</h4>
          <p class="needHover">换一换</p>
        </div>
        <ul class="news-list">
          <li class="needHover">1 新闻标题xxxxxx</li>
          <li class="needHover">2 新闻标题xxxxxx</li>
          <li class="needHover">3 新闻标题xxxxxx</li>
          <li class="needHover">3 新闻标题xxxxxx</li>
          <li class="needHover">3 新闻标题xxxxxx</li>
          <li class="needHover">3 新闻标题xxxxxx</li>
          <li class="needHover">3 新闻标题xxxxxx</li>
          <li class="needHover">3 新闻标题xxxxxx</li>
          <li class="needHover">3 新闻标题xxxxxx</li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>

<style>
  .needHover:hover {
    color: red;
    cursor: pointer;
  }

  .news-list {
    list-style-type: none;
    padding-left: 0;
  }

  .news-list>li {
    font-size: 20px;
    margin: 16px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/rebang/rebang.vue